export const checkIsNaN = (value: unknown): boolean => {
	if (typeof value === 'number' && isNaN(value)) {
		return true;
	}
	if (typeof value === 'string' && value === 'NaN') {
		return true;
	}
	return false;
};
